var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBackup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_817",
    "data-name": "Rectangle 817",
    width: 36,
    height: 36,
    fill: "#325ae7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "backup",
    transform: "translate(-491 -223)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_815",
    "data-name": "Rectangle 815",
    width: 60,
    height: 60,
    rx: 5,
    transform: "translate(491 223)",
    fill: "#f4f5fe"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_973",
    "data-name": "Group 973",
    transform: "translate(503 235)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_973-2",
    "data-name": "Group 973",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8541",
    "data-name": "Path 8541",
    d: "M36,18A18,18,0,0,1,0,18a1.35,1.35,0,0,1,2.7,0A15.3,15.3,0,1,0,5.626,9H8.55a1.35,1.35,0,1,1,0,2.7H2.25A1.35,1.35,0,0,1,.9,10.35V4.05a1.35,1.35,0,1,1,2.7,0V7.2A18,18,0,0,1,36,18M13.821,24.6a4.79,4.79,0,0,1-1.669-9.279,6.322,6.322,0,0,1,11.7,0A4.79,4.79,0,0,1,22.18,24.6H13.821Zm0-2.7H22.18a2.09,2.09,0,0,0,0-4.179h-.557a3.622,3.622,0,1,0-7.244,0h-.557a2.09,2.09,0,1,0,0,4.179",
    fill: "#325ae7"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackup);
export default __webpack_public_path__ + "static/media/backup.14121193fd200b1e0ae59e14050ae965.svg";
export { ForwardRef as ReactComponent };